import Cookies from 'js-cookie'

class UserUtils {

  static isLogin() {
    // const userData = this.getCacheUserData();
    // if(userData){
    //   return userData;
    // }
    // console.log(userData);
    return Cookies.get("token")
  }

  static cacheUserData(data) {
    localStorage.setItem(`user`, JSON.stringify(data));
    if (data.token) {
      Cookies.set("token", data.token);
    }
  }

  static getCacheUserData() {
    const data = localStorage.getItem(`user`)
    return data ? JSON.parse(data) : null;
  }

  static getUserDuty() {
    const data = localStorage.getItem(`user`)
    return data ? JSON.parse(data).duty : -1;
  }

  static getUserFirmId() {
    const data = localStorage.getItem(`user`)
    return data ? JSON.parse(data).firmId : "";
  }

  static getCacheUserDatas() {
    const data = localStorage.getItem(`user`)
    return data;
  }

  static getCacheToken() {
    // const userData = this.getCacheUserData()
    // return userData ? userData.token : "";
    return Cookies.get("token")
  }

  static clearToken() {
    Cookies.remove("token")
  }

}

export default UserUtils;
